package com.neurobs.ccabserver.subjectsessionview.states

import com.neurobs.ccab.IdentityData
import com.neurobs.react.{ContextBase, GenericState, GenericStateGenerator}
import com.neurobs.util.Guid
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.ReactElement

case class UserState(userData: IdentityData)

object UserState extends ContextBase[UserState] {
	override protected def defaultStateValue() = UserState(IdentityData(
		userUuid = Guid.nullGuid,
		accountUuid = Guid.nullGuid,
		email = "",
		givenName = "",
		familyName = "",
		legacyAccountId = 0,
		legacyUserId = 0,
		groups = Seq()
	))
}